module.exports = __webpack_public_path__ + "static/media/HCMM898.b9071bf9.jpg";